import { createFeatureSelector, createSelector } from '@ngrx/store';
import { handleActions } from 'redux-actions';
import {
  IEntityList,
  IFilteredLists,
  initialListState,
} from '../entity-data/entity-data.reducer';
import { EntityTypesEnum } from '../../app.enum';
import {
  documentReducerMap,
  IDocumentState,
} from '../document-data/document-data.reducer';
import { DEFAULT_SEARCH_PARAMS } from './estimate-data.data';
import { ActionsEnum, EnableJobDialog } from './estimate-data.actions';

// feature name
export const FEATURE_NAME = 'estimate-data';

// state interface
export interface IJobDialog {
  clientId: string;
  documentId: string;
}

export interface IState extends IDocumentState {
  jobDialog: IJobDialog;
}

// initial state of store
export const initialDocumentListState: IEntityList = {
  ...initialListState,
  searchParams: DEFAULT_SEARCH_PARAMS,
};

export const initialFilteredListsState: IFilteredLists = {
  done: initialDocumentListState,
  pending: initialDocumentListState,
  search: initialDocumentListState,
};

export const initialState: IState = {
  filteredLists: initialFilteredListsState,
  editingEntity: null,
  selectedEntities: null,
  masterError: null,
  dispatchedResponse: null,
  tmpCache: null,
  jobDialog: null,
};

// reducers
const reducerFn = handleActions(
  {
    ...documentReducerMap<IState>(),
    [ActionsEnum.ENABLE_JOB_DIALOG]: function (
      state: IState,
      { payload }: EnableJobDialog
    ): IState {
      const { clientId, documentId } = payload;

      return {
        ...state,
        jobDialog: { clientId, documentId },
      };
    },
    [ActionsEnum.DISABLE_JOB_DIALOG]: function (
      state: IState,
    ): IState {
      return {
        ...state,
        jobDialog: null
      };
    },
  } as any,
  initialState
);

// filter actions by entityType
export function reducer(state: IState = initialState, action: any) {
  return action.payload &&
    action.payload.entityType === EntityTypesEnum.estimate
    ? reducerFn(state, action)
    : state;
}

// selectors
export const selectFeature = createFeatureSelector<IState>(FEATURE_NAME);

export function getJobDialog() {
  return createSelector(selectFeature, (state: IState) => state.jobDialog);
}
